import { DEVICE_ROLES } from '@/features/core/container';
import { MetricResolutionAggregator, MetricResolutionTimeSource, SpotRole } from '@/types/iot-portal';
import { option } from '@/util/container';
import { component } from '../component';
import lg from './individual-meter-gas-meter-lg.svg';
import md from './individual-meter-gas-meter-md.svg';
import sm from './individual-meter-gas-meter-sm.svg';

export default option(DEVICE_ROLES, async () => ({
  name: SpotRole.INDIVIDUAL_METER_GAS_METER,
  label: 'Individueller_Gaszähler',
  shortLabel: 'INDGAS',
  icons: { sm, md, lg },
  component: component('individual-meter-gas-meter/IndividualMeterGasMeterDevicePanel.vue'),
  aggregationWidget: {
    enabled: true,
    component: component('individual-meter-gas-meter/IndividualMeterGasGasMeterAggregationWidget.vue'),
  },
  defaultMetricNames: ['currentVolume'],
  importantMetricNames: ['currentVolume'],
  aggregationMetricNames: [
    {
      name: 'currentVolume',
      aggregators: [MetricResolutionAggregator.MEAN],
      timeSource: MetricResolutionTimeSource.START,
    },
  ],
  consumption: true,
}));
